import { defineNotificationCategory, extractRelativeActionUrl } from './types';

export const feedbackDescriptor = defineNotificationCategory('feedback', {
  isAvailable: () => true,
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  serverCopy: {
    titleKey: 'feedback.title',
    bodyKey: 'feedback.body',
    values: (data) => ({ form: data.feedbackFormName }),
  },
  pills: (data) => [data.feedbackFormName, 'Feedback'],
});

export const ideaCommentsDescriptor = defineNotificationCategory('idea_comments', {
  isAvailable: () => true,
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  serverCopy: {
    titleKey: 'ideaComments.title',
    bodyKey: 'ideaComments.body',
    values: (data) => ({ ideaTitle: data.ideaTitle }),
  },
  pills: () => ['Comments'],
});

export const commentMentionDescriptor = defineNotificationCategory('comment_mention', {
  isAvailable: () => true,
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  serverCopy: {
    titleKey: 'commentMention.title',
    bodyKey: 'commentMention.body',
    values: (data) => ({ entityTitle: data.entityTitle, entityType: data.entityType }),
  },
  pills: () => ['Mention'],
});

export const staleIdeasDescriptor = defineNotificationCategory('stale_ideas', {
  isAvailable: () => true,
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  serverCopy: {
    titleKey: 'staleIdeas.title',
    bodyKey: 'staleIdeas.body',
    values: (data) => ({ count: data.staleIdeasCount }),
  },
  pills: () => ['Planning'],
});
